/**
 * @description List all the reasons for the exchange account disconnection
 */
export const EXCHANGE_ACCOUNT_DISCONNECTION_REASONS = {
  SUB_ACCOUNT_REMOVED_BY_ADMIN: "SUB_ACCOUNT_REMOVED_BY_ADMIN",
  INVALID_KYC_STATUS: "INVALID_KYC_STATUS",
  ACCOUNT_REMOVED_NO_ACCOUNT_ID: "ACCOUNT_REMOVED_NO_ACCOUNT_ID",
  KRAKEN_TX_HISTORY_REQUIRED: "KRAKEN_TX_HISTORY_REQUIRED",
} as const;
export type EXCHANGE_ACCOUNT_DISCONNECTION_REASONS =
  (typeof EXCHANGE_ACCOUNT_DISCONNECTION_REASONS)[keyof typeof EXCHANGE_ACCOUNT_DISCONNECTION_REASONS];

/**
 * Error codes returned by the exchange-account module API.
 * Shared between API (domain errors) and frontend (error handling).
 */
export const EXCHANGE_ACCOUNT_ERROR_CODES = {
  EXCHANGE_ACCOUNT_HAS_ACTIVE_BOTS: "EXCHANGE_ACCOUNT_HAS_ACTIVE_BOTS",
  EXCHANGE_ACCOUNT_RECONNECTION_REQUIRED: "EXCHANGE_ACCOUNT_RECONNECTION_REQUIRED",
} as const;
export type ExchangeAccountErrorCode = (typeof EXCHANGE_ACCOUNT_ERROR_CODES)[keyof typeof EXCHANGE_ACCOUNT_ERROR_CODES];
